export const filterExistedItems = (productValues, memberValues) => {
  const itemIds = productValues?.map((item) => item?.id);

  const mappingValue = memberValues
    ?.filter((item) => !itemIds?.includes(item?.id))
    .map((item) => ({
      ...item,
      key: item.id,
    }));

  return mappingValue;
};

// Preserve manually selected contactIds and certificateIds

// When a new location is selected,
// only add its associated contactIds and certificateIds,
// without removing any existing manually selected IDs.

// When a location is deselected,
// remove only the IDs that were associated via that location,
// but keep any IDs that were manually selected by the user.
export const updateSelectedRowKey = ({ prev, key, value, locationList }) => {
  if (key === 'locationIds') {
    const prevLocationIds = prev.locationIds;

    // Determine which locations were added or removed
    const added = value.filter((id) => !prevLocationIds.includes(id));
    const removed = prevLocationIds.filter((id) => !value.includes(id));

    // Get associated contacts and certificates from newly added locations
    const addedLocations = locationList.filter((loc) => added.includes(loc.id));
    const addedContacts = addedLocations.flatMap(
      (loc) => loc.associateContactIds
    );
    const addedCertificates = addedLocations.flatMap(
      (loc) => loc.associateCertificateIds
    );

    // Get associated contacts and certificates from removed locations
    const removedLocations = locationList.filter((loc) =>
      removed.includes(loc.id)
    );
    const removedContacts = removedLocations.flatMap(
      (loc) => loc.associateContactIds
    );
    const removedCertificates = removedLocations.flatMap(
      (loc) => loc.associateCertificateIds
    );

    // Get remaining selected locations (after update)
    const remainingLocations = locationList.filter((loc) =>
      value.includes(loc.id)
    );
    const stillUsedContactIds = new Set(
      remainingLocations.flatMap((loc) => loc.associateContactIds)
    );
    const stillUsedCertificateIds = new Set(
      remainingLocations.flatMap((loc) => loc.associateCertificateIds)
    );

    // Keep contact and certificate IDs that were manually selected by user
    const userSelectedContactIds = prev.contactIds.filter(
      (id) => !removedContacts.includes(id)
    );
    const userSelectedCertificateIds = prev.certificateIds.filter(
      (id) => !removedCertificates.includes(id)
    );

    // Merge manual selections and newly added IDs, and filter out those no longer linked
    const updatedContactIds = Array.from(
      new Set([...userSelectedContactIds, ...addedContacts])
    ).filter(
      (id) => stillUsedContactIds.has(id) || prev.contactIds.includes(id)
    );

    const updatedCertificateIds = Array.from(
      new Set([...userSelectedCertificateIds, ...addedCertificates])
    ).filter(
      (id) =>
        stillUsedCertificateIds.has(id) || prev.certificateIds.includes(id)
    );

    return {
      ...prev,
      locationIds: value,
      contactIds: updatedContactIds,
      certificateIds: updatedCertificateIds,
    };
  } else {
    // Directly update contactIds or certificateIds selected manually
    return { ...prev, [key]: value };
  }
};
